import React, { useState, useEffect } from 'react';
import TopicCard from './TopicCard';
import { useUser } from '../UserContext';

const Topic = () => {
  const [topics, setTopics] = useState([]);
  const [error, setError] = useState(null);
  const { user } = useUser();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await fetch(`${apiUrl}/api/student/topics/${user.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        console.log('fetched topics →', data);
        setTopics(data);
      } catch (err) {
        console.error('Error fetching topics:', err);
        setError('Failed to fetch topics. Please try again later.');
      }
    };

    if (user && user.id) {
      fetchTopics();
    } else {
      setError('User not logged in.');
    }
  }, [user]);

  // Filter out anything whose status (case-insensitive) is "completed"
  const visibleTopics = topics.filter(
    (topic) =>
      typeof topic.status === 'string' &&
      topic.status.toLowerCase() !== 'completed'
  );

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
        Your Modules
      </h1>

      {error && <p className="text-red-500 text-center">{error}</p>}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {visibleTopics.length > 0 ? (
          visibleTopics.map((topic) => (
            <TopicCard key={topic.id} topic={topic} />
          ))
        ) : (
          !error && (
            <p className="text-center text-gray-600 col-span-full">
              No active modules to show.
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default Topic;
